import React, { useEffect, useState } from 'react';
import { SyncRegularIcon } from 'src/monet/icons';
import { useStepEditorContext } from 'src/store/step-editor';
import { useCurrentOrganization } from 'src/store/organization';
import { apiGetAllJourneys } from 'src/utils/journeyApi';
import { getWordWithCount } from 'src/utils/text';

interface Props {
  onReady: () => void;
}

export const StepEditorContentFormSyncedStepCopy = ({ onReady }: Props) => {
  const { currentOrganization } = useCurrentOrganization();
  const nodeId = useStepEditorContext((state) => state.node_id);
  const isSynced = useStepEditorContext((state) => state.is_synced);

  const [journeysCount, setJourneysCount] = useState(0);

  useEffect(() => {
    if (!isSynced || !nodeId) {
      onReady();
      return;
    }

    apiGetAllJourneys(currentOrganization.id, { nodeId: nodeId as any })
      .then((response) => {
        setJourneysCount(response.journeys.length);
      })
      .then(onReady);
  }, [currentOrganization.id, onReady, nodeId, isSynced]);

  if (!nodeId) return null;
  if (!isSynced) return null;
  if (journeysCount === 0) return null;

  return (
    <div className='flex space-x-sm p-md items-center bg-bedrock-orange rounded-lg text-bedrock-black'>
      <SyncRegularIcon />
      <span className='text-bedrock-p'>
        This Step is synced across {getWordWithCount('Journey', 'Journeys', journeysCount)}
      </span>
    </div>
  );
};
